import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Show;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Alert } from '@instructure/ui-alerts';
import { Button } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import { withStyleOverrides } from '@instructure/quiz-common';
import { jsx } from '@instructure/emotion';
import { RichContentRenderer } from '@instructure/quiz-rce';
import { AttemptHistory } from '@instructure/quiz-taking';
import { QuizInfo } from './QuizInfo';
import { AccessCodeTextInput, CustomPropTypes, Card, Page, QuizzesSpinner as Spinner } from '@instructure/quiz-core';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';

// ================================

// this is the landing page for a student
// to come begin their quiz taking

// ================================

export var Show = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Show = /*#__PURE__*/function (_Component) {
  function Show() {
    var _this;
    _classCallCheck(this, Show);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Show, [].concat(args));
    _defineProperty(_this, "storeBeginButtonRef", function (c) {
      _this.beginButtonRef = c;
    });
    _defineProperty(_this, "checkSubmitAccessCode", function (e) {
      if (e.keyCode === 13) {
        _this.submitAccessCode();
      }
    });
    _defineProperty(_this, "submitAccessCode", function () {
      if (_this.props.accessCode.length > 0) {
        _this.props.submitStudentAccessCode(_this.props.quizSessionId, _this.props.accessCode);
      }
    });
    _defineProperty(_this, "renderAccessCodeAlert", function () {
      // null won't display anything
      if (_this.props.accessCodeStatus === false) {
        return jsx(Alert, {
          variant: "error",
          renderCloseButtonLabel: t('Close'),
          margin: "small none"
        }, t('Invalid access code!'));
      } else if (_this.props.accessCodeStatus === true) {
        return jsx(Alert, {
          variant: "success",
          renderCloseButtonLabel: t('Close'),
          margin: "small none"
        }, t('Access code successful. You may now begin this assessment.'));
      }
    });
    _defineProperty(_this, "updateAccessCode", function (event) {
      var updateAccessCodeUi = _this.props.updateAccessCodeUi;
      updateAccessCodeUi(_this.accessCodeInput.value);
    });
    _defineProperty(_this, "handleAccessCodeInputRef", function (node) {
      _this.accessCodeInput = node;
    });
    return _this;
  }
  _inherits(Show, _Component);
  return _createClass(Show, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.loadQuizSession();
      this.loadQuiz();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props = this.props,
        updateAccessCodeUi = _this$props.updateAccessCodeUi,
        clearAccessCodeStatus = _this$props.clearAccessCodeStatus;
      updateAccessCodeUi('');
      clearAccessCodeStatus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var loading = false;
      if (this.props.quizSessionId !== prevProps.quizSessionId) {
        this.loadQuizSession();
        loading = true;
      }
      if (this.props.quizId !== prevProps.quizId) {
        this.loadQuiz();
        loading = true;
      }
      if (loading) {
        return;
      }
      var _this$props2 = this.props,
        accessCodeStatus = _this$props2.accessCodeStatus,
        shouldShowLinkButton = _this$props2.shouldShowLinkButton;
      if (accessCodeStatus && shouldShowLinkButton) {
        setTimeout(function () {
          ReactDOM.findDOMNode(_this2.beginButtonRef).focus();
        });
      }
    }
  }, {
    key: "loadQuiz",
    value: function loadQuiz() {
      var _this$props3 = this.props,
        quizId = _this$props3.quizId,
        getExistingQuiz = _this$props3.getExistingQuiz;
      if (quizId) {
        getExistingQuiz(quizId);
      }
    }
  }, {
    key: "loadQuizSession",
    value: function loadQuizSession() {
      var _this$props4 = this.props,
        quizSessionId = _this$props4.quizSessionId,
        confirmSessionStartPage = _this$props4.confirmSessionStartPage;
      if (quizSessionId) {
        confirmSessionStartPage(quizSessionId);
      }
    }
  }, {
    key: "handleLinkButtonClick",
    value: function handleLinkButtonClick() {
      var quizSession = this.props.quizSession;
      if (quizSession) {
        if (quizSession.graded()) return this.props.onIsGraded;
        if (quizSession.needsGrading()) return this.props.onNeedsGrading;
        if (quizSession.taking()) return this.props.onInProgress;
        if (quizSession.pending() || quizSession.failedToStart()) return this.props.onIsPending;
      }
    }
  }, {
    key: "buttonLabel",
    value: function buttonLabel() {
      if (this.props.buttonLabel) return this.props.buttonLabel;
      var quizSession = this.props.quizSession;
      if (quizSession.submitted()) return t('View Results');
      if (quizSession.pending() || quizSession.failedToStart()) return t('Begin');
      return t('Resume');
    }
  }, {
    key: "renderLinkButton",
    value: function renderLinkButton() {
      var _this$props5 = this.props,
        quizSession = _this$props5.quizSession,
        shouldShowBeginButton = _this$props5.shouldShowBeginButton,
        shouldShowLinkButton = _this$props5.shouldShowLinkButton;

      // Short-circuit this - no button if we have no quizSession
      if (!quizSession) return null;
      var isBeginButton = quizSession.pending() || quizSession.failedToStart();
      if (isBeginButton && !shouldShowBeginButton || !shouldShowLinkButton) {
        return null;
      }
      return jsx(Button, {
        ref: this.storeBeginButtonRef,
        color: "primary",
        onClick: this.handleLinkButtonClick(),
        "data-automation": "sdk-start-resume-button"
      }, this.buttonLabel());
    }
  }, {
    key: "renderBacktrackingAlert",
    value: function renderBacktrackingAlert() {
      if (!this.props.isOneAtATime || this.props.allowBacktracking) {
        return;
      }
      return jsx("div", {
        css: this.props.styles.sectionWrapper
      }, jsx(Alert, {
        variant: "info"
      }, jsx("div", null, jsx(Text, {
        lineHeight: "double"
      }, jsx(Text, {
        weight: "bold"
      }, t('Backtracking disabled')), jsx("br", null), jsx(Text, {
        weight: "light"
      }, t("This assessment is delivered one question at a time. Viewing and going back to\n                  a previously answered question (backtracking) is not allowed. Exercise caution\n                  when navigating through this assessment."))))));
    }
  }, {
    key: "renderAccessCode",
    value: function renderAccessCode() {
      var _this$props6 = this.props,
        accessCode = _this$props6.accessCode,
        accessCodePromptPermitted = _this$props6.accessCodePromptPermitted,
        accessCodeStatus = _this$props6.accessCodeStatus,
        quiz = _this$props6.quiz,
        quizSession = _this$props6.quizSession;
      if (!accessCodePromptPermitted || !quizSession || quizSession.submitted()) {
        return null;
      }
      if (quiz.requireStudentAccessCode && !quizSession.acceptedStudentAccessCode) {
        var messages = accessCodeStatus === false ? [{
          text: t('Please enter a valid passcode'),
          type: 'error'
        }] : [];
        return jsx("div", {
          css: this.props.styles.accessCodeWrapper
        }, jsx("div", null, jsx(Text, {
          color: "primary"
        }, quizSession.pending() ? t('An access code is required to start') : t('An access code is required to resume'))), jsx("div", null, jsx(AccessCodeTextInput, {
          inputRef: this.handleAccessCodeInputRef,
          messages: messages,
          onChange: this.updateAccessCode,
          onKeyDown: this.checkSubmitAccessCode,
          "data-automation": "sdk-access-code-textinput"
        })), jsx("div", null, jsx(Button, {
          color: "primary",
          onClick: this.submitAccessCode,
          disabled: accessCode.length === 0,
          "data-automation": "sdk-submit-access-code-button"
        }, t('Submit'))));
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      if (this.props.children) {
        return jsx("div", {
          css: this.props.styles.sectionWrapper
        }, this.props.children);
      }
    }
  }, {
    key: "renderSubmitSection",
    value: function renderSubmitSection() {
      var _this$props7 = this.props,
        quiz = _this$props7.quiz,
        quizSession = _this$props7.quizSession;
      if (!quizSession) {
        // When we don't have a quiz session, we're just looking at instructions and stuff
        // aka "observer mode"
        return null;
      } else if (quiz.filterIpAddress && !quizSession.ipIsAllowed) {
        // Don't render this stuff if ip is invalid
        return jsx(Alert, {
          variant: "error",
          margin: "small"
        }, t('Your IP address is not authorized'));
      } else if (!quiz.valid) {
        return jsx(Alert, {
          variant: "error",
          margin: "small"
        }, t('There is a problem with this assessment. Please contact your instructor.'));
      } else {
        return jsx("div", {
          css: this.props.styles.sectionWrapper
        }, jsx(AttemptHistory, {
          attemptHistory: this.props.attemptHistory,
          averageScore: this.props.averageScore,
          findAuthoritativeAttempt: this.props.findAuthoritativeAttempt,
          gradingScheme: this.props.gradingScheme,
          onAttemptClick: this.props.onAttemptClick,
          quizId: quiz.id,
          restrictQuantitativeData: this.props.restrictQuantitativeData,
          scoreToKeep: this.props.scoreToKeep,
          selectedSessionId: this.props.quizSessionId
        }), this.renderAccessCodeAlert(), this.renderAccessCode(), this.renderLinkButton());
      }
    }
  }, {
    key: "renderShow",
    value: function renderShow() {
      return jsx(Page, {
        contentRole: this.props.contentRole
      }, jsx(Card, {
        wrapped: true,
        css: this.props.styles.quizShow
      }, jsx("div", {
        css: this.props.styles.sectionWrapper
      }, jsx(Heading, {
        level: "h1",
        color: "primary"
      }, this.props.quiz.title)), jsx("div", {
        css: _objectSpread(_objectSpread({}, this.props.styles.sectionWrapper), this.props.styles.clearfix),
        "data-resource-type": "quiz",
        "data-resource-id": this.props.quiz.id
      }, jsx(RichContentRenderer, {
        content: this.props.quiz.instructions
      })), jsx("div", {
        css: this.props.styles.sectionWrapper
      }, jsx(QuizInfo, {
        quiz: this.props.quiz,
        quizSession: this.props.quizSession,
        hasSubmission: this.props.hasSubmission,
        hideInstructions: this.props.hideInstructions
      })), this.renderChildren(), this.renderBacktrackingAlert(), this.renderSubmitSection()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
        quiz = _this$props8.quiz,
        quizSession = _this$props8.quizSession;
      if (quiz.isLoaded() && (!quizSession || quizSession.isLoaded())) {
        return this.renderShow();
      } else {
        return jsx(Card, {
          wrapped: true
        }, jsx(Spinner, null));
      }
    }
  }]);
}(Component), _defineProperty(_Show, "displayName", 'Show'), _defineProperty(_Show, "componentId", "Quizzes".concat(_Show.displayName)), _defineProperty(_Show, "propTypes", {
  accessCode: PropTypes.string.isRequired,
  accessCodePromptPermitted: PropTypes.bool,
  accessCodeStatus: PropTypes.bool,
  allowBacktracking: PropTypes.bool.isRequired,
  attemptHistory: CustomPropTypes.attemptHistory,
  averageScore: CustomPropTypes.numberInRange(0, 1),
  buttonLabel: PropTypes.string,
  children: PropTypes.node,
  clearAccessCodeStatus: PropTypes.func.isRequired,
  confirmSessionStartPage: PropTypes.func.isRequired,
  contentRole: PropTypes.string,
  findAuthoritativeAttempt: PropTypes.func,
  getExistingQuiz: PropTypes.func.isRequired,
  gradingScheme: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number
  })),
  hasSubmission: PropTypes.bool,
  isOneAtATime: PropTypes.bool.isRequired,
  onAttemptClick: PropTypes.func,
  onInProgress: PropTypes.func.isRequired,
  onIsGraded: PropTypes.func,
  onIsPending: PropTypes.func.isRequired,
  onNeedsGrading: PropTypes.func,
  quiz: ImmutablePropTypes.record.isRequired,
  quizId: PropTypes.string,
  quizSession: ImmutablePropTypes.record,
  quizSessionId: PropTypes.string,
  restrictQuantitativeData: PropTypes.bool,
  scoreToKeep: PropTypes.string,
  shouldShowBeginButton: PropTypes.bool.isRequired,
  shouldShowLinkButton: PropTypes.bool.isRequired,
  submitStudentAccessCode: PropTypes.func.isRequired,
  updateAccessCodeUi: PropTypes.func.isRequired,
  styles: PropTypes.object,
  hideInstructions: PropTypes.bool
}), _defineProperty(_Show, "defaultProps", {
  accessCodePromptPermitted: true,
  accessCodeStatus: null,
  attemptHistory: null,
  averageScore: void 0,
  buttonLabel: null,
  children: null,
  contentRole: void 0,
  findAuthoritativeAttempt: null,
  gradingScheme: [],
  hasSubmission: false,
  onAttemptClick: function onAttemptClick() {},
  onIsGraded: function onIsGraded() {},
  onNeedsGrading: function onNeedsGrading() {},
  quizId: null,
  quizSession: null,
  quizSessionId: null,
  restrictQuantitativeData: false,
  scoreToKeep: 'highest',
  hideInstructions: false
}), _Show)) || _class);
export default Show;